import type { HtmlHTMLAttributes } from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export function Main2({ className, ...mainProps }: HtmlHTMLAttributes<HTMLDivElement>) {
  const { container } = mainStyles();

  return (
    <main
      className={cn(container(), "tw:flex tw:flex-col tw:gap-5 tw:py-6", className)}
      {...mainProps}
    />
  );
}

export const mainStyles = tv({
  slots: {
    container: cn(
      "tw:mx-auto tw:w-full tw:max-lg:mx-8",
      "tw:lg:max-w-(--content-max-width-lg)! tw:xl:max-w-(--content-max-width-xl)!",
    ),
  },
});
